import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { setActiveNotesFiltersId, upsertNotesFiltersSuccess, } from './notes-filters.actions';
import { NotesFiltersInterface } from './notes-filters.service';

export interface NotesFiltersState extends EntityState<NotesFiltersInterface> {
  activeNotesFiltersId: string;
}

export const notesFiltersAdapter: EntityAdapter<NotesFiltersInterface> = createEntityAdapter<NotesFiltersInterface>({
  selectId: (notesFilters: NotesFiltersInterface) => notesFilters?.id
});

export const initialState: NotesFiltersState = notesFiltersAdapter.getInitialState({
  activeNotesFiltersId: null,
});


export const notesFiltersReducers = createReducer(
  initialState,
  on(upsertNotesFiltersSuccess, (state, { notesFilters }) =>
    notesFiltersAdapter.upsertOne({ ...state.entities[notesFilters.id], ...notesFilters }, state)
  ),
  on(setActiveNotesFiltersId, (state, { notesFiltersId }) => ({
    ...state,
    activeNotesFiltersId: notesFiltersId
  }))
);

export function notesFiltersReducer(state: NotesFiltersState | undefined, action: Action) {
  return notesFiltersReducers(state, action);
}

